<template>
  <layout titlePage="Lista de presentes" class="layout-dashboard">
    <div class="dashboard-content">
      <GiftMenu ref="giftMenu" />
      <GiftEdit v-if="giftsTab == 'editar-lista'" />
      <div v-if="giftsTab == 'recebidos'">
        <GiftListBoard />
        <GiftList />
      </div>
      <GiftConfig v-if="giftsTab == 'configurar-lista'" />
      <GiftExternalList v-if="giftsTab == 'listas-externas'" />
      <GiftAbout v-if="giftsTab == 'sobre-a-lista'" />
      <OnboardingModal ref="onboardingModal" />
    </div>
  </layout>
</template>

<script>
import layout from '@/layouts/Default.vue'
import GiftMenu from '@/components/Gift/GiftMenu.vue'
import GiftListBoard from '@/components/Gift/GiftListBoard.vue'
import GiftList from '@/components/Gift/GiftList/GiftList.vue'
import GiftAbout from '@/components/Gift/GiftAbout.vue'
import GiftExternalList from '@/components/Gift/GiftExternalList/GiftExternalList.vue'
import GiftConfig from '@/components/Gift/GiftConfig/GiftConfig.vue'
import GiftEdit from '@/components/Gift/GiftEdit.vue'

import OnboardingModal from '@/components/Gift/Onboarding/OnboardingModal.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'GiftsDashboard',
  components: {
    GiftMenu,
    GiftListBoard,
    GiftList,
    layout,
    OnboardingModal,
    GiftAbout,
    GiftExternalList,
    GiftConfig,
    GiftEdit,
  },

  metaInfo: {
    title: 'Lista de presentes',
  },

  computed: {
    giftsTab: {
      get() {
        return this.$store.state.gifts.tab
      },
      set(payload) {
        this.$store.dispatch('gifts/setGiftsTab', payload)
      },
    },
  },

  mounted() {
    this.giftsTab = this.$route.params.tab ?? 'editar-lista'
    this.fetchGiftsFromCatalog()
  },

  methods: {
    ...mapActions({
      fetchGiftsFromCatalog: 'gifts/fetchGiftsFromCatalog',
    }),

    OnboardingModal() {
      this.$refs.onboardingModal.open()
    },
  },
}
</script>

<style lang="scss" scoped>
.layout-dashboard {
  background-color: #fff;
}
.dashboard-content {
  padding: 0 16px 24px;
  margin: 0 auto;
  width: 100%;
  @media screen and (min-width: 1024px) {
    padding: 0 24px 24px;
  }
  @media screen and (min-width: 1366px) {
    max-width: 1344px;
  }
  @media screen and (min-width: 1919px) {
    padding: 0 0 24px;
  }
}
</style>
